import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import { orangeGradientFontStyle } from '../../fontStyles';
import { makeHitArea } from 'Engine/utils/makeHitArea';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';
import eEventTypes from '../../enums/eEventTypes';
import { uiConfig } from '../ui/config';
import UiAdapterExtended from '../ui/uiAdapterExtended';

export default class StartScreenContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.onKeyDown = this.onKeyDown.bind(this);

    this.init();
    this.addListeners();
  }


  onResize(data) {
    if (data.isMobile && data.isPortrait) {
      this.background.goToFrame(1)
      this.content.visible = false;
      this.portraitContent.visible = true;
      this.startButton.pivot.x = this.startButton.displayData.width / 2;
      this.startButton.x = this.startButton.displayData.x + this.startButton.displayData.width / 2;
      // this.startButton.scale.set(1.25);
      this.startButton.y = this.startButton.displayData.y + 360;
    } else {
      this.background.goToFrame(2)
      this.content.visible = true;
      this.portraitContent.visible = false;
      this.startButton.pivot.x = 0;
      this.startButton.x = this.startButton.displayData.x;
      // this.startButton.scale.set(this.startButton.displayData.scaleX);
      this.startButton.y = this.startButton.displayData.y;
    }
  }

  init() {
    this.content = this.getChildByName('content');
    this.portraitContent = this.getChildByName('portraitContent');
    this.background = this.getChildByName('background');
    this.visible = false;
    this.eventMode = 'static';
    this.startButton = this.getChildByName('startButton');
    makeHitArea(this.startButton);
    this.setTextsStyle();
    this.setWinAmounts();

  }

  addListeners() {
    GlobalDispatcher.addOnce(eEventTypes.EET_START_SCREEN__SHOW, this.show.bind(this));
    this.startButton.on('pointertap', this.hide, this);
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onResize,
      this
    );
  }

  setTextsStyle() {
    const setFunction = (content) => {
      for (let i = 0; i < 6; i++) {
        if (i === 2) continue;
        const text = content.getChildByName(`start_screen_${i}`);
        text.style = { ...text.style, ...orangeGradientFontStyle };
      }
      const winAmount = content.getChildByName(`start_screen_max_win_amount`);
      winAmount.style = { ...winAmount.style, ...orangeGradientFontStyle };
    }
    const startButtonText = this.startButton.getChildByName('start_screen_play');
    startButtonText.style = {
      ...startButtonText.style,
      ...orangeGradientFontStyle,
      dropShadow: true,
      dropShadowBlur: 6,
      dropShadowColor: '#510754',
      dropShadowDistance: 0,
    };
    setFunction(this.content);
    if (EntryPoint.mobile) setFunction(this.portraitContent);

  }

  setWinAmounts() {
    const setFunction = (content) => {
      const maxWinField = content.getChildByName(`start_screen_max_win_amount`)
      // maxWinField.text = MoneyFormat.format(EntryPoint.GameModel.jackpotMaxWin, false); // temp comment
    }
    setFunction(this.content);
    if (EntryPoint.mobile) setFunction(this.portraitContent);
  }

  onKeyDown(event) {
    if (event.keyCode === 32) {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }
  }

  show() {
    document.addEventListener('keydown', this.onKeyDown)
    this.startButton.enabled = true;
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.startButton.enabled = false;
    GlobalDispatcher.dispatch(eEventTypes.EET_START_SCREEN__HIDE);
    SoundManager.play(eSounds.EST_BACKGROUND.soundName, eSounds.EST_BACKGROUND.volume, true, eSounds.EST_BACKGROUND.group);
    document.removeEventListener('keydown', this.onKeyDown);
    OPWrapperService.freeBetsController.show();
    const ControllerUi = window.OPWrapperService.initUi(uiConfig);
    new UiAdapterExtended(ControllerUi).init({
      bonusLabelText: 'FREESPINS',
      clickSound: eSounds.EST_BUTTON_CLICK
    });
  }
}
